/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlanResponseDto } from './PlanResponseDto';
import {
    PlanResponseDtoFromJSON,
    PlanResponseDtoFromJSONTyped,
    PlanResponseDtoToJSON,
    PlanResponseDtoToJSONTyped,
} from './PlanResponseDto';

/**
 * 
 * @export
 * @interface ListPlansResponseDto
 */
export interface ListPlansResponseDto {
    /**
     * 
     * @type {Array<PlanResponseDto>}
     * @memberof ListPlansResponseDto
     */
    data: Array<PlanResponseDto>;
}

/**
 * Check if a given object implements the ListPlansResponseDto interface.
 */
export function instanceOfListPlansResponseDto(value: object): value is ListPlansResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListPlansResponseDtoFromJSON(json: any): ListPlansResponseDto {
    return ListPlansResponseDtoFromJSONTyped(json, false);
}

export function ListPlansResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListPlansResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(PlanResponseDtoFromJSON)),
    };
}

export function ListPlansResponseDtoToJSON(json: any): ListPlansResponseDto {
    return ListPlansResponseDtoToJSONTyped(json, false);
}

export function ListPlansResponseDtoToJSONTyped(value?: ListPlansResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(PlanResponseDtoToJSON)),
    };
}

